import script from "./GeneratingView.vue?vue&type=script&setup=true&lang=js"
export * from "./GeneratingView.vue?vue&type=script&setup=true&lang=js"

import "./GeneratingView.vue?vue&type=style&index=0&id=2c7c7871&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2c7c7871"]])

export default __exports__